export function filteredAttributes() {
    const attrs = [
        {
            name:'sort',
            label:'Sort',
            urlLabel:'Sort',
            type:'select_group', 
            displaySelected:true, 
            singleSelect:true,
            default:'ppc_asc'
        },
        {
            name:'shape',
            label:'shape',
            urlLabel:'Shape',
            type:'select', 
            displaySelected:false, 
            singleSelect:false,
            default:null,
            config:{}
        },
        {
            name:'fiery_round',
            label:'Fiery Round',
            urlLabel:'FieryRound',
            type:'select',
            displaySelected:false,
            singleSelect:true,
            default:null,
            config:{}
        },
        {
            name:'report',
            label:'Report',
            urlLabel:'Report',
            type:'checkbox', 
            displaySelected:false, 
            singleSelect:false,
            default:null,
            config:{}
        },
        {
            name:'quickship',
            label:'Quickship',
            urlLabel:'Quickship',
            type:'checkbox', 
            displaySelected:false, 
            singleSelect:false,
            default:'yes',
            config:{}
        },
        {
            name:'listview',
            label:'Listview',
            urlLabel:'Listview',
            type:'checkbox', 
            displaySelected:false, 
            singleSelect:false,
            default:'yes',
            config:{}
        },
        // {
        //     name:'blockchain',
        //     label:'TRACEABILITY',
        //     urlLabel:'Blockchain',
        //     type:'checkbox', 
        //     displaySelected:false, 
        //     singleSelect:false,
        //     default:'yes',
        //     config:{}
        // },
        {
            name:'price',
            label:'Price',
            urlLabel:'Price',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'num', format:{ notation:'$', position:'prepend' }}
        },
        {
            name:'carat',
            label:'Carat',
            urlLabel:'Carat',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:0.01, type: 'num', format:{notation:' ct', position:'append'}}
        },
        {
            name:'depth',
            label:'Depth %',
            urlLabel:'Depth',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:0.01, type: 'num', format:{notation:'%', position:'append'}}
        },
        {
            name:'ratio',
            label:'LW Ratio',
            urlLabel:'LWRatio',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{ step:0.01, type: 'num'}
        },
        {
            name:'table',
            label:'Table %',
            urlLabel:'Table',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:0.01, type: 'num', format:{ notation:'%', position:'append' }}
        },
        {
            name:'color',
            label:'Color',
            urlLabel:'Color',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'cut',
            label:'Cut',
            urlLabel:'Cut',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'clarity',
            label:'Clarity',
            urlLabel:'Clarity',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'polish',
            label:'Polish',
            urlLabel:'Polish',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'symmetry',
            label:'Symmetry',
            urlLabel:'Symmetry',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'fluorescence',
            label:'Fluorescence',
            urlLabel:'Fluorescence',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            config:{step:1, type: 'alpha'}
        },
        {
            name:'filterby',
            label:'Filterby',
            urlLabel:'Filterby',
            type:'checkbox',
            displaySelected:false,
            singleSelect:false,
            default:null,
            config:{}
        },
        {
            name:'estdate',
            label:'Estdate',
            urlLabel:'Estdate',
            type:'select', 
            displaySelected:true, 
            singleSelect:true,
            default:'anydate'
        },
        // {
        //     name:'price',
        //     label:'Price',
        //     urlLabel:'Price',
        //     type:'slider', 
        //     displaySelected:true, 
        //     singleSelect:true,
        //     default:null,
        //     options:{}
        // }

    ]

    return attrs;
}